import { CallDto } from '@act/shared/data-transfer-objects';
import { useInteractionsDialog } from '../../../dialog-forms/hooks/useInteractionsDialog.hook';
import { getCallFullScreenSaveAndClose } from '../FullScreenSaveClose.utils';
import { useCallback } from 'react';
import { setMinimizedCallId } from 'redux/slices/callsSlice.slice';
import { useAppDispatch } from 'redux/storeHooks';
import { clearMinimizeNavigation } from '../callMinimizeNavigation.util';
import { useMinimizedCallBannerPresentation } from './useMinimizedCallBannerPresentation.hook';

/**
 * Restores the fullscreen call view from the minimized dock.
 * Cancels any pending post-minimize member-page navigation so early restore
 * does not navigate away when the minimize animation timeout later fires.
 *
 * @param call - Call to reopen in the interactions dialog.
 * @returns Handler that clears minimized state and reopens the call UI when needed.
 */
export function useMinimizedCallRestore(call: CallDto | undefined) {
  const dispatch = useAppDispatch();
  const interactionsDialog = useInteractionsDialog();
  const { subjectUser } = useMinimizedCallBannerPresentation(call);

  const restoreCallView = useCallback(() => {
    if (!call) {
      return;
    }

    clearMinimizeNavigation();
    dispatch(setMinimizedCallId(null));

    const callDialogIsMounted = getCallFullScreenSaveAndClose() != null;
    if (!callDialogIsMounted && subjectUser) {
      interactionsDialog.editCall({ call, user: subjectUser });
    }
  }, [call, subjectUser, dispatch, interactionsDialog]);

  return restoreCallView;
}
